import React from 'react';
import Modal from 'react-responsive-modal';

import NavBar from '../../components/navigation/NavBar';
import ModalDialog from '../../components/modal/ModalDialog';
import KatottgTree from '../../components/katottgtree/KatottgTree';
import Label from '../../components/input/Label';
import InputText from '../../components/input/InputText';

import { getCurrentResource } from '../../util/tools';
import { performApiRequest, performApiRequestForm, 
	KATOTTG_IMPORT_API_URL, KATOTTG_SAVERECORD_API_URL,
} from '../../util/restapi';
import { isSuperUser, } from '../../util/localStorage';

import iconEdit from '../../assets/icons/png24x24/edit.png';
import iconShow from '../../assets/icons/png24x24/Search.png';
import iconImport from '../../assets/icons/png24x24/get_message.png';

const MODAL_MODE_ACTIVE = 'a';
const MODAL_MODE_WAIT = 'w';
const MODAL_MODE_COMPLETE = 'c';
const MODAL_MODE_ERROR = 'e';

class KatottgPage extends React.Component {
	
	constructor(props) {
		super(props);
		this.refKatottgTree = React.createRef();
		this.refKatottgEditModalDialog = React.createRef();
		this.resource = getCurrentResource().pages.admin.KatottgPage;
	}
	componentDidMount = async () => {
		document.title = 'BOM. КАТОТТГ';
	}

	openEditModalDialog = (readOnly) => {
		if( this.refKatottgTree.current ) {
			let treeNode = this.refKatottgTree.current.selectedNode;
			if( treeNode ) {
				this.refKatottgEditModalDialog.current.katottgRecord = treeNode.record;
				this.refKatottgEditModalDialog.current.readOnly = readOnly;
				this.refKatottgEditModalDialog.current.buttonCancelText = readOnly ? 'Закрити' : 'Відмінити';
				this.refKatottgEditModalDialog.current.showOkButton = ! readOnly;
				this.refKatottgEditModalDialog.current.openModal();
			}
		}
	}	
	
	render() {
		return (
			<React.Fragment>
				<NavBar app={this.props.app} />
				<div style={{textAlign: 'left'}}>
					<div style={{display: 'flex', padding: '10px', backgroundColor: 'rgb(245,245,245)', }}>
						<div style={{
							padding: '5px 20px 0 20px',backgroundColor: 'rgb(200,230,200)',
							fontWeight: 'bold', fontSize: '14pt'
						}}>
							КАТОТТГ
						</div>
						<button type='button' style={{marginLeft: '5px', width: '36px', height: '30px'}}
							 onClick={() => this.openEditModalDialog(false)}
							 title={'Редагувати запис КАТОТТГ'} 
						>
							<img src={iconEdit} />
						</button>
						<button type='button' style={{marginLeft: '5px', width: '36px', height: '30px'}}
							 onClick={() => this.openEditModalDialog(true)}
							 title={'Переглянути запис КАТОТТГ'} 
						>
							<img src={iconShow} />
						</button>
						<ControlPanelButtonImport holder={this} />
						<KatottgEditModalDialog ref={this.refKatottgEditModalDialog} page={this}/>
					</div>
					<KatottgTree ref={this.refKatottgTree} />
				</div>
			</React.Fragment>
		)
	}
}

class KatottgEditModalDialog extends ModalDialog {

	katottgRecord = {};
	readOnly = false;
	
	constructor(props) {
		super(props);
		this.title='Запис КАТОТТГ';
		this.buttonOkText = 'Записати';
	}
	getStyleModal() {
		let style = super.getStyleModal();
		style.modal.maxWidth = '600px';
		return style;
	}
	async performRequest() {
		let request = {record: this.katottgRecord};
		let response = await performApiRequest(KATOTTG_SAVERECORD_API_URL, request);
		if( response.success ) {
			let katottgPage = this.props.page;
			let treeNode = katottgPage.refKatottgTree.current.selectedNode;
			treeNode.updateRecord( this.katottgRecord );
		}
		return response;
	}
	onChange = (id, event, value) => {
		//if( id == 'code' )
		//	this.katottgRecord.code = event.target.value;
		//else 
		if( id == 'name' )
			this.katottgRecord.name = value;
		else if( id == 'populationTotalSize' )
			this.katottgRecord.populationTotalSize = value;
		else if( id == 'populationMenSize' )
			this.katottgRecord.populationMenSize = value;
		else if( id == 'populationWomenSize' )
			this.katottgRecord.populationWomenSize = value;
		else if( id == 'populationChildrenSize' )
			this.katottgRecord.populationChildrenSize = value;
	}
	
	renderForm() {
		let record = this.katottgRecord;
		let readOnly = this.readOnly;
		return (
			<div style={{marginTop: '10px', padding: '10px'}}>
				<div style={{display: 'flex', alignItems: 'center'}}>
					<Label title='Код' tooltip='Код запису КАТОТТГ' styles={{divMain: {marginRight: '5px'}}}/>
					<InputText id='code' value={record.code} readOnly={true} />
					<Label title='Назва' tooltip='Назва територіальної громади' styles={{divMain: {marginLeft: '20px', marginRight: '5px'}}}/>
					<InputText id='name' value={record.name} onChange={this.onChange} readOnly={readOnly} />
				</div>

				<div style={{display: 'flex', alignItems: 'center', marginTop: '20px'}}>
					<Label title='Загальна кількість населення' tooltip='Загальна кількість населення що зареєстрована в територіальній громаді' 
						styles={{divMain: {marginRight: '5px'}}}
					/>
					<InputText id='populationTotalSize' value={record.populationTotalSize} onChange={this.onChange} readOnly={readOnly} />
				</div>
				<div style={{color: 'darkBlue'}}>
					в тому числі
				</div>
				<div style={{marginLeft: '50px'}}> 
					<div style={{display: 'flex', alignItems: 'center', marginTop: '10px'}}>
						<Label title='чоловіків' tooltip='Кількість чоловіків що зареєстрована в територіальній громаді' 
							styles={{divMain: {marginRight: '5px', width: '80px'}}}
						/>
						<InputText id='populationMenSize' value={record.populationMenSize} onChange={this.onChange} readOnly={readOnly} />
					</div>
					<div style={{display: 'flex', alignItems: 'center', marginTop: '10px'}}>
						<Label title='жінок' tooltip='Кількість жінок що зареєстрована в територіальній громаді' 
							styles={{divMain: {marginRight: '5px', width: '80px'}}}
						/>
						<InputText id='populationWomenSize' value={record.populationWomenSize} onChange={this.onChange} readOnly={readOnly} />
					</div>
					<div style={{display: 'flex', alignItems: 'center', marginTop: '10px'}}>
						<Label title='дітей' tooltip='Кількість дітей що зареєстрована в територіальній громаді' 
							styles={{divMain: {marginRight: '5px', width: '80px'}}}
						/>
						<InputText id='populationChildrenSize' value={record.populationChildrenSize} onChange={this.onChange} readOnly={readOnly} />
					</div>
				</div>
			</div>
		)
	}
}

class ControlPanelButtonImport extends React.Component {
	
	constructor(props) {
		super(props);
		this.resource = props.holder.resource;
		this.fileImportRef = React.createRef();
		this.file = null;
		this.resultMessage = '';
		this.resultLog = '';
		this.state = {
			modalMode: MODAL_MODE_ACTIVE,
			fileName: this.resource.textSelectFile,
			isModalOpen: false,
		};
	}
	openModal = () => {
		this.setState({isModalOpen: true});
	}
	closeModal = () => {
		this.setState({isModalOpen: false})
	}
	initModal = () => {
		this.file = null;
		this.resultMessage = '';
		this.resultLog = '';
		this.setState({
			modalMode: MODAL_MODE_ACTIVE,
			fileName: this.resource.textSelectFile,
		});
	}
	tryAgain = () => {
		this.setState({	modalMode: MODAL_MODE_ACTIVE});
	}

	handleFileSelect = (e) => {
		let files = e.target.files;
		if( files && files.length > 0 ) {
			this.file = files[0];
			this.setState({fileName: this.file.name})
		}
	}	

	startImport = async () => {
		this.setState({modalMode: MODAL_MODE_WAIT})
		const form = new FormData();
		form.append('file', this.file);
		let response = await performApiRequestForm(KATOTTG_IMPORT_API_URL, form);
		if( response.success ) {
			this.resultMessage = response.message;
			this.resultLog = response.log;
			if( this.resultMessage == '' ) {
				this.resultMessage = this.resource.messageImportComplete;
			} 
			this.setState({modalMode: MODAL_MODE_COMPLETE})
		} else {
			this.resultMessage = response.message; 
			this.resultLog = response.log;
			this.setState({modalMode: MODAL_MODE_ERROR})
		}
	}

	render() {
		if( ! isSuperUser() ) 
			return null;
			
		let resource = this.resource;
		let modalBodyHtml = null;
		if( this.state.modalMode == MODAL_MODE_COMPLETE ) {
			let divAdditionalMessage = null;
			if( this.resultLog ) {
				divAdditionalMessage = (
					<div style={{marginLeft: 'auto', marginRight: 'auto', marginBottom: '30px', width: '95%'}}>
						<textarea style={{width: '100%'}} rows="8" readOnly={true}>
							{this.resultLog}
						</textarea>
					</div>		
				);
			}
			modalBodyHtml = (
				<React.Fragment>
					<div style={{color: 'red', textAlign: 'center', padding: '30px', fontSize: '16pt'}} 
						dangerouslySetInnerHTML={{__html: this.resultMessage}}
					/>
					{divAdditionalMessage}
					<div style={localStyles.divButtons}>
						<button type='button' onClick={this.tryAgain} >
							{resource.buttonTryAgain}
						</button>
					</div>
				</React.Fragment>
			);
		} else {
			let buttonImportDisabled = this.state.modalMode == MODAL_MODE_WAIT || this.file == null;
			let divWaiting = this.state.modalMode == MODAL_MODE_WAIT ?
				(<div style={localStyles.divWaiting}>{resource.waiting}</div>) : null;  
			modalBodyHtml = (
				<div style={{margin: '15px'}}>
					<div>
						{resource.labelFile}: 
						<span style={{marginLeft: '5px', marginRight: '10px'}}>{this.state.fileName}</span> 
						<button onClick={e => this.fileImportRef.current.click()}>...</button>
						<input ref={this.fileImportRef} type={'file'} style={{display: 'none'}} 
							onChange={e => this.handleFileSelect(e)} 
						/>
					</div>
					{divWaiting}
					<div style={localStyles.divButtons}>
						<button type='button' title={resource.buttonImportTooltip}
							onClick={this.startImport} disabled={buttonImportDisabled}
						>
							{resource.buttonImport}
						</button>
					</div>
				</div>
			);
		}

		return (
			<React.Fragment>
				<button type='button' style={{marginLeft: '5px', width: '36px', height: '30px'}}
					 onClick={this.openModal}
					 title={'Імпортувати записи КАТОТТГ з файлу csv'} 
				>
					<img src={iconImport} />
				</button>
				<Modal 
					open={this.state.isModalOpen} onClose={this.closeModal} center 
					styles={styleModal} closeOnOverlayClick={false} animationDuration={1} 
				>
					<div>
						<div style={localStyles.divHeader}>
							{this.resource.modalImportTitle}
						</div>
						{modalBodyHtml}
					</div>
				</Modal>
			</React.Fragment>	
		);
	}
}

const styleModal = {
	modal: {
		background: '#ffffff',
		padding: '0px',
		borderRadius: '21px',
		maxWidth: '500px',
		width: '100%',
	},
	closeButton: {
		top: '10px',
		right: '10px',
		fill: '#FF0000',
		outline: 'none',
	},
};

const localStyles = {
	divHeader: {
		fontSize: '16pt',
		textAlign: 'center',
		padding: '10px',
		borderRadius: '21px 21px 0 0',
		backgroundColor: '#F0F0F0'
	},
	divParameters: {
		marginTop: '10px',
		padding: '10px'
	},
	divWaiting: {
		textAlign: 'center',
		padding: '7px'
	},
	divButtons: {
		marginTop: '7px',
		padding: '10px',
		marginRight: '15px',
		textAlign: 'right'
	}
};

export default KatottgPage;
